'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** ./~/history/ExecutionEnvironment.js
 ** module id = 228
 ** module chunks = 0
 **/